import { LOCATION_CHANGE } from 'react-router-redux';
import { combineActions, handleActions } from 'redux-actions';
import { mapReducersFromConfigurations } from '../../helpers/reducer';
import businessActions from '../business/actions';
import userActions from '../user/actions';
import { configurations } from './configurations';

export const initialState = {
  isFetching: false,
  error: undefined,
  plans: [],
  cardDetails: undefined,
  isFetchingCoupon: false,
  coupon: undefined,
  stripeSubscription: undefined,
  upcomingInvoice: undefined,
};

const reducer = handleActions({
  ...mapReducersFromConfigurations('payment')(configurations),
  [combineActions(userActions.user.api.cancelSubscription.success,
    businessActions.business.api.cancelSubscription.success)]: (state, action) => ({
      ...state,
      error: undefined,
      cardDetails: undefined
    }),
  [LOCATION_CHANGE]: (state, action) => ({
    ...state,
    isFetching: false,
    isFetchingCoupon: false,
    error: undefined
  })
}, {
    ...initialState
  });

export default reducer;



// WEBPACK FOOTER //
// ./src/state/modules/payment/reducers.js